export default {
  showPreview: 'Show signal preview',
  hidePreview: 'Hide signal preview',
};
